import { render, staticRenderFns } from "./SupplierGeneralFirstList.vue?vue&type=template&id=e13b4606&scoped=true&"
import script from "./SupplierGeneralFirstList.vue?vue&type=script&lang=js&"
export * from "./SupplierGeneralFirstList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGeneralFirstList.vue?vue&type=style&index=0&id=e13b4606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13b4606",
  null
  
)

export default component.exports